import { Button, Card, Typography } from "@mui/material";
import React from "react";
import {
  StyledNotificationSetupContent,
  StyledNotificationSetupText,
} from "./styles";
import useNotificationsAccessHelper from "../../../hooks/useNotificationsAccessHelper";
import { toast } from "react-toastify";
import { showErrors } from "../../../utils/ui";

const NotificationSetupDetails = () => {
  const {
    isNotificationSupported,
    currentDeviceEnrolled,
    unsubscribe,
    setupSubscription,
  } = useNotificationsAccessHelper();
  const [processing, setIsProcessing] = React.useState(false);

  const statusText = isNotificationSupported
    ? currentDeviceEnrolled
      ? "Enabled"
      : "Disabled"
    : "Unsupported";

  const onUpdate = async () => {
    setIsProcessing(true);
    try {
      if (currentDeviceEnrolled) {
        await unsubscribe();
        toast.info("Notifications disabled");
      } else {
        await setupSubscription();
        toast.success("Notifications enabled");
      }
    } catch (e) {
      showErrors(e);
    }
    setIsProcessing(false);
  };
  return (
    <Card variant="outlined">
      <StyledNotificationSetupContent>
        <StyledNotificationSetupText>
          <Typography variant="body2">Notifications Status</Typography>
          <Typography variant="caption" color="textSecondary">
            {statusText}.
          </Typography>
        </StyledNotificationSetupText>
        <Button
          variant="outlined"
          size="small"
          disabled={!isNotificationSupported || processing}
          onClick={onUpdate}
        >
          {currentDeviceEnrolled ? "Unsubscribe" : "Subscribe"}
        </Button>
      </StyledNotificationSetupContent>
    </Card>
  );
};

export default NotificationSetupDetails;
